/* eslint-disable react/prop-types */
import * as React from 'react'

import { cn } from 'components/lib/utils'

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    // BL-4176: shadcn's default focus-visible:outline-none + ring-* removed.
    // Focus indicators flow through .focus-ring-* classes (see index.css) and
    // the global button:focus-visible base rule in styles/colors.css. Don't
    // restore those defaults without coordinating with the design system.
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'

export { Input }
